/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initAddressMaps = () => $('.address-map').each(function() { return initAddressMap($(this)); });

root.initAddressMap = function(mapDiv) {
  let map = mapDiv.data('map');

  // Create Map
  if (!map) {
    let mapOptions;
    const bounds = mapDiv.data('bounds');

    if (bounds) {
      const latLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds[1][1], bounds[1][0]),
        new google.maps.LatLng(bounds[0][1], bounds[0][0]));
      mapOptions =
        {mapTypeId: google.maps.MapTypeId.ROADMAP};

      map = new google.maps.Map(mapDiv[0], mapOptions);
      map.fitBounds(latLngBounds);
      mapDiv.data('map', map);
    } else {
      mapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoom: 15
      };

      map = new google.maps.Map(mapDiv[0], mapOptions);
      mapDiv.data('map', map);
    }
  }

  let marker = mapDiv.data('marker');

  // Create Marker
  if (!marker) {
    const centerLocation = mapDiv.data('center-location');
    if (!centerLocation || (centerLocation.length !== 2)) { return; }

    const location = new google.maps.LatLng(centerLocation[1], centerLocation[0]);
    if (!location) { return; }

    map.setCenter(location);

    marker = new google.maps.Marker({
      map,
      position: location,
      animation: window.DISABLE_ANIMATIONS ? null : google.maps.Animation.DROP
    });
    return mapDiv.data('marker', marker);
  }
};

function initAddressMapsOnLoad() {
  if ($('.address-map').length) {
    initAddressMaps();
  }
}

$(initAddressMapsOnLoad);
document.addEventListener('turbo:load', initAddressMapsOnLoad);
